<template>
    <v-flex v-if="dataProvider && dataProvider.cards" xs12>
        <v-container grid-list-xl>
            <v-layout row wrap justify-center>
                <!--<template v-if="( isMobile && (this.dataProvider.reverseMobile ? true : false))">
                    <fx-card v-for="(item,index) in dataProvider.cards.slice().reverse()" :key="index" :data-provider="item"/>
                </template>
                <template v-else>
                    <fx-card v-for="(item,index) in dataProvider.cards" :key="index" :data-provider="item"/>
                </template>-->
                <fx-card v-for="(item,index) in getCards()" :key="index" :data-provider="item"/>
            </v-layout>
        </v-container>
    </v-flex>
    <fx-anomalie-composant v-else composant="fx-section" propriete="cards"/>
</template>
<script>
    import FxCard from "./FxCard";
    export default {
        name: "fx-section",
        components: { FxCard },
        props: {
            dataProvider: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                isMobile: (['lg','xl'].indexOf(this.$screen.breakpoint) === -1)
            }
        },
        methods: {
            getCards() {
                // ( isMobile && (this.dataProvider.reverseMobile ? true : false)) ? dataProvider.cards.slice().reverse() : dataProvider.cards
                if ( (['lg','xl'].indexOf(this.$screen.breakpoint) === -1) && (this.dataProvider.reverseMobile ? ( this.dataProvider.reverseMobile != '0' ? true : false ) : false)) {
                    return this.dataProvider.cards.slice().reverse()
                }
                return this.dataProvider.cards
            }
        },
    }
</script>
